import React, { useState, useEffect } from "react";
import { notification } from 'antd';
import { SubmitButton, FlexContainer, H1Text, Img, Spinner } from "../../design";
import Select from "react-select";
import { API } from "../../api";
import { MESSAGES } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import SuccessMessageModal from "../../components/modal/successMessage";
import Logo from '../../assets/imgs/SP_Outline_logo.svg';
import UploadConfirmationModal from "./components/UploadConfirmationModal";
import { InfoCircleOutlined } from "@ant-design/icons";


type Props = {
    history: {
        push: Function,
    },
}

const PaypalDocumentUpload = (props: Props) => {
    const [errorMessage, setErrorMessage] = useState('');
    const [showerrorMessage, setShowErrorMessage] = useState(false);
    const [isShowSpinner, setShowSpinner] = useState(false);
    const [linkStatus, setLinkStatus] = useState('');
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [selectedDocument, setSelectedDocument] = useState('');
    const [uploadedUrl, setUploadedUrl] = useState('');
    const [paypalDocReqList, setPaypalDocReqList] = useState('');
    const { location: { search } } = props;

    const params = new URLSearchParams(search);
    const key = params.get('key');


    const onConfirm = async (url) => {
            setConfirmationModal(false);
            setShowErrorMessage(false);
        
            let params = {
                requiredDocumentUrl : uploadedUrl || null,
                documentName: selectedDocument?.label,
                paypalDocumentReferenceId: selectedDocument?.value
            };
            setShowSpinner(true);
            try {
                const { data } = await API.post(`/paypal/document/upload`, params, {
                    headers: {
                    'x-api-key': key ? atob(key) : null,
                    },
                })
                if (data && data.responseCode === 200) {
                   getPaypalDocReqList();
                   notification.info({
                     className: "alert alert-success",
                     icon: <div className="d-flex align-items-center gap-8">
                        <InfoCircleOutlined style={{ fontSize: '20px' }} />
                        <span style={{ fontSize: '15px' }}>Paypal document is successfuly submitted!</span>
                      </div>,
                     duration: 4,
                   })
                   setUploadedUrl('');
                };
            } catch (e) {
                setShowErrorMessage(true);
                setErrorMessage(e?.response?.data ? e.response.data.message : 'Unable to process request. Please try again later');
            } finally {
                setShowSpinner(false);
            }
    };

    const getPaypalDocReqList = async () => {
        const { data : { entity } } = await API.get('/paypal/document/required-document', {
            headers: {
            'x-api-key': key ? atob(key) : null,
            },
        })
        if(entity){
            setPaypalDocReqList(entity?.items || []);
        };
    }

    // to check if the verification link is still valid and active
    useEffect(() => {
        getPaypalDocReqList();
    }, []);
    
    const phoneCustomStyles = {
        control: base => ({
            ...base,
            height: 32,
            minHeight: 32,
            border: '1px solid #29B1CC',
            boxShadow: 'none',
            borderColor: '#29B1CC !important',
            minWidth: '250px',
        }),
    };

    return (
        <>
            <SuccessMessageModal
                isOpen={linkStatus === 'SUBMITTED'}
                successMsg={MESSAGES.ONBOARDING_DOCUMENT_STATUS.SUCCESS}
            />
            <BaseSplitPage left={
                <>
                    <FlexContainer
                        flexDirection="column"
                        position="relative"
                        display="block"
                        height="100%"
                    >
                        <div>
                            <H1Text>
                                PAYPAL DOCUMENT UPLOAD
                            </H1Text>
                        </div>
                        <div style={{ position: "sticky", top: "85%" }}>
                            <Support email={null}
                                phone={null} />
                        </div>
                    </FlexContainer>
                </>
            } right={
                <>
                    <Header payment={null} />
                    <FlexContainer
                        className="pt-3 pt-lg-5"
                        box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                        display="flow-root"
                    >

                        <H1Text
                            className="px-1 px-md-4 mt-4"
                        >
                            SUBMIT DOCUMENT FOR PAYPAL VERIFICATION
                        </H1Text>
                        <hr className="my-2"/>
                        <div className="px-1 px-md-4 mt-2">
                            <FlexContainer flexDirection="column">
                                <div className="d-flex mt-4 mb-4">
                                  <Img src={Logo} />
                                  <H1Text className="px-1 px-md-4 mt-4">
                                    UPLOAD DOCUMENT(S)
                                  </H1Text>
                                </div>
                                {paypalDocReqList.length > 0 &&
                                    paypalDocReqList.map((item, index) => {
                                        return (
                                        <div key={index}>
                                            <div className="d-flex align-items-center mb-4" style={{ gap: '1rem', flexWrap: 'wrap' }}>
                                            <Select
                                                className="px-0 border-0"
                                                theme={theme => ({
                                                    ...theme,
                                                    borderRadius: "4px",
                                                    boxShadow: 0,
                                                })}
                                                getOptionLabel={(option) => option.label}
                                                getOptionValue={(option) => option.value}
                                                styles={phoneCustomStyles}
                                                options={item?.group?.items.map(doc => ({
                                                    label: doc.friendlyName,
                                                    value: doc.documentId,
                                                }))}
                                                placeholder="Select document type..."
                                                value={selectedDocument['rowIndex'] === index ? selectedDocument : ''}
                                                onChange={(selected) => {
                                                  setSelectedDocument({...selected, rowIndex: index });
                                                }}
                                            />
                                            {selectedDocument?.rowIndex === index ? 
                                              <SubmitButton 
                                                onClick={() => setConfirmationModal(true)}
                                                style={{ height: '2rem', fontSize: '13px', margin: '10px' }}
                                              >
                                                Upload
                                              </SubmitButton>
                                            : null }
                                            </div>
                                        </div>
                                        );
                                })}
                            </FlexContainer>
                        </div>
                    </FlexContainer>
                    <Spinner isOpen={isShowSpinner} />
                    {showerrorMessage && <PaymentError header={"Error"} message={errorMessage} />}
                    <UploadConfirmationModal
                      confirmationModal={confirmationModal}
                      publicKeyUrl={key ? atob(key) : ''}
                      uploadedUrl={uploadedUrl}
                      setConfirmationModal={setConfirmationModal}
                      setUploadedUrl={setUploadedUrl}
                      selectedDocument={selectedDocument}
                      onClose={() => { setConfirmationModal(false); setUploadedUrl(''); }}
                      onSubmit={onConfirm}
                    />
                </>
            } />
        </>
    )
};

export default PaypalDocumentUpload;
